"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('selectTimeZoneOption', function selectTimeZoneOption(timeZone) {
    var optionState = store_1.default();
    optionState.selectedTimeZone = timeZone;
});
//# sourceMappingURL=selectTimeZoneOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/selectTimeZoneOption.js
// module id = 4943
// module chunks = 2